(function () {
  let crossSellTooltipIcons = [];
  let isCrossSellTooltipListenerBound = false;

  const closeAllCrossSellTooltips = () => {
    crossSellTooltipIcons.forEach((icon) => {
      icon.classList.remove("active");
      icon.setAttribute("aria-expanded", "false");
    });
  };

  const initProductAccordion = () => {
    const toggles = document.querySelectorAll(".about__accordion-toggle");

    toggles.forEach((toggle) => {
      toggle.addEventListener("click", (event) => {
        event.preventDefault();
        const description = toggle.nextElementSibling?.classList.contains(
          "about__accordion-description"
        )
          ? toggle.nextElementSibling
          : toggle.previousElementSibling?.classList.contains(
              "about__accordion-description"
            )
          ? toggle.previousElementSibling
          : null;

        if (description) {
          if (!toggle.classList.contains("active")) {
            slideDown(toggle, description, 300); // func in global.js
          } else {
            slideUp(toggle, description, 300); // func in global.js
          }
        }
      });
    });
  };

  const initCrossSellTooltips = () => {
    const questionIcons = document.querySelectorAll(
      ".choose_variant-question[data-tooltip]"
    );

    crossSellTooltipIcons = Array.from(questionIcons);

    if (!questionIcons.length) {
      return;
    }

    questionIcons.forEach((icon) => {
      icon.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const isActive = icon.classList.contains("active");

        closeAllCrossSellTooltips();

        if (!isActive) {
          icon.classList.add("active");
          icon.setAttribute("aria-expanded", "true");
        }
      });

      icon.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          icon.click();
        }
      });
    });

    if (!isCrossSellTooltipListenerBound) {
      document.addEventListener("click", closeAllCrossSellTooltips);
      isCrossSellTooltipListenerBound = true;
    }
  };

  // Store original pricing for reset functionality
  let originalPricing = null;
  
  // Helper function to format prices (no trailing zeros, integers only)
  const formatPrice = (priceInCents) => {
    const dollars = priceInCents / 100;
    const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(dollars);
    
    return formatted;
  };
  
  // Helper function to format money without trailing zeros (like Liquid's money_without_trailing_zeros)
  const formatMoneyWithoutTrailingZeros = (priceInCents) => {
    const dollars = priceInCents / 100;
    const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(dollars);
    
    return formatted;
  };

  // Helper function to update Klarna custom widget price
  const updateKlarnaPlacement = (priceInCents) => {
    const klarnaPriceElements = document.querySelectorAll('.custom_klarna_widget .klarna_price');
    
    if (klarnaPriceElements.length > 0) {
      // Format the price for display (divided by 24 for monthly payment)
      const formattedPrice = formatPrice(priceInCents / 24);
      
      klarnaPriceElements.forEach((element) => {
        element.textContent = formattedPrice;
      });
    }
  };
  
  const storeOriginalPricing = () => {
    if (originalPricing) return; // Already stored
    
    const priceWrapper = document.querySelector('.price-wrapper');
    const priceElements = document.querySelectorAll('.pdp_price_wrapper .price');
    const firstPriceElement = priceElements[0];
    
    // Get the pricing discount from the data attribute (in cents)
    const pricingDiscount = parseInt(priceWrapper?.dataset.pricingDiscount) || 0;
    
    // For mirror product, the actual product price is the big price (compare-at price)
    // The small price is already calculated as (product price - discount)
    const priceBigItem = firstPriceElement?.querySelector('.price-item--big');
    const priceSmallItem = firstPriceElement?.querySelector('.price-item--small');
    
    // Get the original product price from the big price (this is the base price before discount)
    const bigPriceText = priceBigItem?.textContent || '';
    const bigPriceMatch = bigPriceText.match(/[\d,]+\.?\d*/);
    const originalProductPrice = bigPriceMatch ? parseFloat(bigPriceMatch[0].replace(/,/g, '')) * 100 : 0;
    
    // Also store the original sale price from the small price
    const smallPriceText = priceSmallItem?.textContent || '';
    const smallPriceMatch = smallPriceText.match(/[\d,]+\.?\d*/);
    const originalSalePrice = smallPriceMatch ? parseFloat(smallPriceMatch[0].replace(/,/g, '')) * 100 : 0;
    
    // Store original state for each price element
    const priceElementsData = Array.from(priceElements).map((priceEl) => {
      const itemBig = priceEl.querySelector('.price-item--big');
      const itemSmall = priceEl.querySelector('.price-item--small');
      
      return {
        element: priceEl,
        itemBig: itemBig?.textContent || '',
        itemSmall: itemSmall?.textContent || '',
        itemSmallClass: itemSmall?.className || '',
        hasBigPrice: !!itemBig,
        hasOnSaleClass: priceEl.classList.contains('price--on-sale') || false
      };
    });
    
    // Store original saving amount from badge
    const badgeSavingElement = document.querySelector('.badge-saving-amount');
    const originalSavingAmount = badgeSavingElement ? parseInt(badgeSavingElement.dataset.originalSaving) || 0 : 0;
    
    originalPricing = {
      priceElements: priceElementsData,
      productPrice: originalProductPrice, // The base product price (from big price)
      salePrice: originalSalePrice, // The original sale price (from small price)
      pricingDiscount: pricingDiscount, // The fixed discount amount
      savingAmount: originalSavingAmount // The original saving amount (in cents)
    };
    
    console.log('Original pricing stored:', originalPricing);
  };

  const updateCrossSellPricing = (selectedItem) => {
    // Store original pricing on first call
    storeOriginalPricing();
    
    if (!originalPricing || !originalPricing.priceElements) {
      console.error('Original pricing not stored properly');
      return;
    }
    
    console.log('Price elements found:', originalPricing.priceElements.length);
    
    if (!selectedItem) {
      // Reset to original pricing if no cross-sell item is selected
      originalPricing.priceElements.forEach((priceData) => {
        const priceElement = priceData.element;
        let itemBig = priceElement.querySelector('.price-item--big');
        const itemSmall = priceElement.querySelector('.price-item--small');
        
        // Restore big price if it existed originally
        if (priceData.hasBigPrice) {
          if (!itemBig) {
            // Create big price element if it doesn't exist
            itemBig = document.createElement('span');
            itemBig.className = 'price-item price-item--regular price-item--big';
            priceElement.insertBefore(itemBig, itemSmall);
          }
          itemBig.textContent = priceData.itemBig;
          itemBig.style.display = '';
        } else {
          // Remove big price if it didn't exist originally
          if (itemBig) {
            itemBig.remove();
          }
        }
        
        // Restore small price
        if (itemSmall) {
          itemSmall.textContent = priceData.itemSmall;
          itemSmall.className = priceData.itemSmallClass;
        }
        
        // Restore the original price--on-sale class state
        if (priceData.hasOnSaleClass) {
          priceElement.classList.add('price--on-sale');
        } else {
          priceElement.classList.remove('price--on-sale');
        }
      });
      
      // Restore original saving amount in badge
      const badgeSavingElement = document.querySelector('.badge-saving-amount');
      if (badgeSavingElement && originalPricing.savingAmount) {
        badgeSavingElement.textContent = formatMoneyWithoutTrailingZeros(originalPricing.savingAmount);
      }

      // Restore original main CTA button price
      const mainButtonPriceElement = document.querySelector('.pdp__submit-total');
      if (mainButtonPriceElement) {
        mainButtonPriceElement.textContent = formatPrice(originalPricing.salePrice);
        mainButtonPriceElement.setAttribute('data-base-price', originalPricing.salePrice);
        
        // Restore button label data-label for hover effect
        const buttonLabel = mainButtonPriceElement.closest('.button__label');
        if (buttonLabel) {
          const buttonText = buttonLabel.getAttribute('data-label').split(' ')[0] + ' ' + buttonLabel.getAttribute('data-label').split(' ')[1] + ' ' + buttonLabel.getAttribute('data-label').split(' ')[2] + buttonLabel.getAttribute('data-label').split(' ')[3];
          const addToCartText = buttonText.substring(0, buttonText.lastIndexOf(' '));
          buttonLabel.setAttribute('data-label', addToCartText + ' ' + formatPrice(originalPricing.salePrice));
        }
      }

      // Update Klarna placement with original sale price
      updateKlarnaPlacement(originalPricing.salePrice);
      
      return;
    }
    
    // Get the cross-sell item pricing data from the input element
    const checkbox = selectedItem.querySelector('.pdp_upsell_checkbox');
    console.log('Checkbox element found:', !!checkbox);
    console.log('Checkbox dataset:', checkbox?.dataset);
    
    const crossSellPrice = parseInt(checkbox?.dataset.productPrice) || 0;
    const crossSellComparePrice = parseInt(checkbox?.dataset.productComparePrice) || 0;
    
    console.log('Cross-sell pricing (cents):', { crossSellPrice, crossSellComparePrice });
    
    // Get the original pricing values
    const originalProductPrice = originalPricing.productPrice || 0;
    const originalSalePrice = originalPricing.salePrice || 0;
    
    console.log('Original pricing (cents):', { 
      productPrice: originalProductPrice,
      salePrice: originalSalePrice
    });
    
    // Calculate new pricing:
    // Big price (compare-at) = original product price + cross-sell compare price
    // Small price (sale) = original sale price + cross-sell actual price
    const newCompareAtPrice = originalProductPrice + crossSellComparePrice;
    const newSalePrice = originalSalePrice + crossSellPrice;
    
    console.log('New pricing (cents):', { 
      newCompareAtPrice, 
      newSalePrice,
      calculation: `BigPrice: ${originalProductPrice} + ${crossSellComparePrice} = ${newCompareAtPrice}, SmallPrice: ${originalSalePrice} + ${crossSellPrice} = ${newSalePrice}`
    });
    
    // Calculate new saving amount (difference between displayed prices)
    const newSavingAmount = newCompareAtPrice - newSalePrice;
    console.log('New saving amount (cents):', newSavingAmount);
    
    // Update all price elements
    originalPricing.priceElements.forEach((priceData) => {
      const priceElement = priceData.element;
      let itemBig = priceElement.querySelector('.price-item--big');
      const itemSmall = priceElement.querySelector('.price-item--small');
      
      // Always show sale pricing for mirror products with cross-sell
      priceElement.classList.add('price--on-sale');
      
      // Create or update big price (compare-at price)
      if (!itemBig) {
        itemBig = document.createElement('span');
        itemBig.className = 'price-item price-item--regular price-item--big';
        priceElement.insertBefore(itemBig, itemSmall);
      }
      itemBig.textContent = formatPrice(newCompareAtPrice);
      itemBig.style.display = '';
      
      // Update small price (sale price)
      if (itemSmall) {
        itemSmall.textContent = formatPrice(newSalePrice);
        // Update class to show it's a sale price
        itemSmall.className = 'price-item price-item--sale price-item--small';
      }
    });
    
    // Update saving amount in badge
    const badgeSavingElement = document.querySelector('.badge-saving-amount');
    if (badgeSavingElement && newSavingAmount > 0) {
      badgeSavingElement.textContent = formatMoneyWithoutTrailingZeros(newSavingAmount);
    }

    // Update main CTA button price
    const mainButtonPriceElement = document.querySelector('.pdp__submit-total');
    if (mainButtonPriceElement) {
      mainButtonPriceElement.textContent = formatPrice(newSalePrice);
      mainButtonPriceElement.setAttribute('data-base-price', newSalePrice);
      
      // Update button label data-label for hover effect
      const buttonLabel = mainButtonPriceElement.closest('.button__label');
      if (buttonLabel) {
        const buttonText = buttonLabel.getAttribute('data-label').split(' ')[0] + ' ' + buttonLabel.getAttribute('data-label').split(' ')[1] + ' ' + buttonLabel.getAttribute('data-label').split(' ')[2];
        const addToCartText = buttonText.substring(0, buttonText.lastIndexOf(' '));
        buttonLabel.setAttribute('data-label', addToCartText + ' ' + formatPrice(newSalePrice));
      }
    }

    // Update Klarna placement with new sale price
    updateKlarnaPlacement(newSalePrice);
  };

  const initCrossSellRadioBehavior = () => {
    const crossSellItems = document.querySelectorAll(".choose_variant-add-item");
    
    crossSellItems.forEach((item) => {
      const checkbox = item.querySelector(".pdp_upsell_checkbox");
      const label = item.closest("label");
      
      if (checkbox && label) {
        // Add click handler to the entire card
        label.addEventListener("click", (event) => {
          // Don't trigger if clicking on the question mark icon
          if (event.target.classList.contains("choose_variant-question")) {
            return;
          }
          
          // If this item is already selected, deselect it
          if (checkbox.checked) {
            checkbox.checked = false;
            checkbox.dispatchEvent(new Event("change", { bubbles: true }));
            updateCrossSellPricing(null); // Reset pricing
            return;
          }
          
          // Uncheck all other cross-sell items
          crossSellItems.forEach((otherItem) => {
            const otherCheckbox = otherItem.querySelector(".pdp_upsell_checkbox");
            if (otherCheckbox && otherCheckbox !== checkbox) {
              otherCheckbox.checked = false;
              otherCheckbox.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });
          
          // Check the current item
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event("change", { bubbles: true }));
          
          // Update pricing
          updateCrossSellPricing(item);
        });
        
        // Handle direct checkbox clicks
        checkbox.addEventListener("change", (event) => {
          if (checkbox.checked) {
            // Uncheck all other cross-sell items
            crossSellItems.forEach((otherItem) => {
              const otherCheckbox = otherItem.querySelector(".pdp_upsell_checkbox");
              if (otherCheckbox && otherCheckbox !== checkbox) {
                otherCheckbox.checked = false;
                otherCheckbox.dispatchEvent(new Event("change", { bubbles: true }));
              }
            });
            
            // Update pricing
            updateCrossSellPricing(item);
          } else {
            // Reset pricing when unchecked
            updateCrossSellPricing(null);
          }
        });
      }
    });
  };

  let countdownInterval;

  const initProductCountdown = () => {
    const countDownWrapper = document.querySelector(".product-countdown");
    if (!countDownWrapper) return;

    const userDate = countDownWrapper.getAttribute("data-date");
    const userTime = countDownWrapper.getAttribute("data-time");

    if (!userDate || !userTime) return;

    removeProductCountdown();

    countdownInterval = setInterval(
      () => updateTimer(countDownWrapper, userDate, userTime),
      1000
    );

    updateTimer(countDownWrapper, userDate, userTime);
  };

  const removeProductCountdown = () => {
    clearInterval(countdownInterval);
  };

  const updateTimer = (wrapper, userDate, userTime) => {
    const completedCountdown = wrapper.getAttribute("data-completed");
    const countdown = wrapper.querySelector(".product-countdown__main");
    const countdownHeading =
      wrapper.querySelector(".product-countdown__end-info") || null;
    const countdownPromo =
      wrapper.querySelector(".product-countdown__promo") || null;

    const countdownDate = new Date(`${userDate}T${userTime}`);
    const now = new Date();
    const distance = countdownDate - now;

    if (distance < 0) {
      removeProductCountdown();
      handleCountdownEnd(
        wrapper,
        countdown,
        countdownHeading,
        completedCountdown,
        countdownPromo
      );
    } else {
      displayTime(wrapper, distance);
    }
  };

  const handleCountdownEnd = (
    wrapper,
    countdown,
    countdownHeading,
    completedCountdown,
    countdownPromo
  ) => {
    if (completedCountdown === "hide_section") {
      wrapper.style.display = "none";
    } else if (completedCountdown === "show_text") {
      countdown.style.display = "none";
      if (countdownPromo) countdownPromo.style.display = "none";
      if (countdownHeading) countdownHeading.style.display = "flex";
    }
  };

  const displayTime = (wrapper, distance) => {
    const daysEl = wrapper.querySelector(".product-countdown_block_days");
    const hoursEl = wrapper.querySelector(".product-countdown_block_hours");
    const minutesEl = wrapper.querySelector(".product-countdown_block_minutes");
    const secondsEl = wrapper.querySelector(".product-countdown_block_seconds");

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    daysEl.textContent = formatTime(days);
    hoursEl.textContent = formatTime(hours);
    minutesEl.textContent = formatTime(minutes);
    secondsEl.textContent = formatTime(seconds);
  };

  const formatTime = (time) => (time < 10 ? `0${time}` : time);

  const revealPopup = (section) => {
    if (!section || !section.classList.contains("product-section")) return;
    const buyButtons = section.querySelector(
      ".product__buy-buttons > product-form"
    );
    const stickyBar = document.querySelector(".product-countdown");
    const footerBottom = document.querySelector(
      ".shopify-section-group-footer-group .footer-bottom"
    );

    if (!stickyBar) return;

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.01,
    };

    const isElementBelowScroll = (element) => {
      return element ? element.getBoundingClientRect().top > 0 : false;
    };

    const toggleStickyBar = (isVisible) => {
      if (isVisible || isElementBelowScroll(buyButtons)) {
        stickyBar.classList.remove("active");
        removeProductCountdown();
      } else {
        stickyBar.classList.add("active");
        initProductCountdown();
      }
    };

    const handleIntersect = (entries) => {
      const isVisible = entries.some((entry) => entry.isIntersecting);
      toggleStickyBar(isVisible);
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);

    if (buyButtons) observer.observe(buyButtons);
    if (footerBottom) observer.observe(footerBottom);
  };

const initMediaToggleButtons = () => {
  const toggleTracks = document.querySelectorAll(
    ".product__media-toggle-track"
  );

  if (!toggleTracks.length) {
    return;
  }

  const updateMediaDisplay = () => {
    const mediaItem = toggleTracks[0].closest(".product__media-item");

    if (!mediaItem) {
      return;
    }

    const originalMedia = mediaItem.querySelector(".product__media img, .product__media video");
    const inHomeMedia = mediaItem.querySelector(".alternative-media--in-home");
    const mountedMedia = mediaItem.querySelector(".alternative-media--mounted");
    const bothMedia = mediaItem.querySelector(".alternative-media--both");

    const originalTrack = mediaItem.querySelector(
      '.product__media-toggle-track[data-toggle="original"]'
    );
    const alternativeTrack = mediaItem.querySelector(
      '.product__media-toggle-track[data-toggle="alternative"]'
    );

    const isOriginalActive = originalTrack?.classList.contains("active");
    const isAlternativeActive = alternativeTrack?.classList.contains("active");

    // Hide all media first
    if (originalMedia) {
      originalMedia.style.display = "none";
    }
    if (inHomeMedia) {
      inHomeMedia.style.display = "none";
    }
    if (mountedMedia) {
      mountedMedia.style.display = "none";
    }
    if (bothMedia) {
      bothMedia.style.display = "none";
    }

    // Show appropriate media based on toggle states
    if (isOriginalActive && isAlternativeActive) {
      // Both active → show 4th image
      if (bothMedia) {
        bothMedia.style.display = "block";
      } else if (originalMedia) {
        originalMedia.style.display = "block";
      }
    } else if (isOriginalActive && !isAlternativeActive) {
      // Only "In Home" active → show 2nd image
      if (inHomeMedia) {
        inHomeMedia.style.display = "block";
      } else if (originalMedia) {
        originalMedia.style.display = "block";
      }
    } else if (!isOriginalActive && isAlternativeActive) {
      // Only "Mounted" active → show 3rd image
      if (mountedMedia) {
        mountedMedia.style.display = "block";
      } else if (originalMedia) {
        originalMedia.style.display = "block";
      }
    } else {
      // Both inactive → show 1st image (original)
      if (originalMedia) {
        originalMedia.style.display = "block";
      }
    }
  };

  const toggleTracksArray = Array.from(toggleTracks);

  toggleTracksArray.forEach((track) => {
    track.addEventListener("click", (event) => {
      event.preventDefault();

      // Toggle the clicked track's state independently
      track.classList.toggle("active");

      // Update media display based on both toggle states
      updateMediaDisplay();
    });
  });

  // Initialize default state - both toggles inactive
  updateMediaDisplay();
};

  document.addEventListener("shopify:section:load", (event) => {
    initProductAccordion();
    initCrossSellTooltips();
    initCrossSellRadioBehavior();
    revealPopup(event.target);
    initMediaToggleButtons();
  });

  initProductAccordion();
  initCrossSellTooltips();
  initCrossSellRadioBehavior();
  revealPopup(document.currentScript.parentElement);
  initMediaToggleButtons();
})();
